import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';

import moment, { Moment } from 'moment';
import Swal from 'sweetalert2';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { isArray } from '@apollo/client/utilities';
import { ProjectsService } from '../../../services/proyectos/projects.service';
import { FiltersM } from '../../../components/models';
import { messages } from '../../funciones/mensajes';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-plan-accion',
  templateUrl: './plan-accion.component.html',
  styleUrl: './plan-accion.component.css'
})
export class PlanAccionComponent {
  Filters = FiltersM;
  proyects = [];
  activities: any[] = [];
  gant: any[] = [];
  aditionals = [];
  modalProjects = false;
  modalActivities = false;
  modalAdittional = false;
  viewTablero = false;
  years = [];
  
  public viewResponsables = [];
  public viewResponsablesActivity = [];
  public viewAllresponsibles = true;
  public viewAllresponsiblesActivity = true;

  private gantGroupId;
  private gantActivityId;
  public gantAditionalId;
  mostrarAllPlanes = false;

  public allocationId = undefined;
  private questionaryId = undefined;
  public allocation = [];
  private answersSheet = [];
  public responsibles = [];
  
  private haveInformation = false;
  private info;
  public edit = false;
  public questionsForPlans = [];
  public questionsSelect = [];
  public responsables = [
    { id: '1', name: 'Juan Pérez' },
    { id: '2', name: 'María García' },
    { id: '3', name: 'Carlos López' },
    { id: '4', name: 'Ana Martínez' },
    { id: '5', name: 'Pedro Rodríguez' },
  ];

  public editTable = true;

  public formProy = new FormGroup({
    name: new FormControl('',[Validators.required]),
    responsible: new FormControl(''),
    questionId: new FormControl('',[Validators.required]),
  });
  public formActi = new FormGroup({
    name: new FormControl('',[Validators.required]),
    start_date: new FormControl('',[Validators.required]),
    end_date: new FormControl('',[Validators.required]),
    responsible: new FormControl('', [Validators.required]),
  });
  public formAdit = new FormGroup({
    name: new FormControl('',[Validators.required]),
    type: new FormControl('',[Validators.required]),
  }, { validators: this.nombreDuplicidad()});

  private defaultValuesProy = {
    name: '',
    questionId: '',
    responsable: '',
  }
  private defaultValuesActi = {
    name: '',
    start_date: '',
    end_date: '',
    responsable: '',
  }
  private defaultValuesAdit = {
    name: '',
    type: '',
  }

  public prefix = '';
  public suffix = '';
  public miles = ',';
  public decimal = '.';
  public precicion = 0;
  public aling = '';

  constructor(
    public dataService: DataService,
    private route: Router,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private service: ProjectsService,
  ){
    if(
      this.route.getCurrentNavigation() &&
      this.route.getCurrentNavigation().extras !== undefined &&
      this.route.getCurrentNavigation().extras.state !== undefined &&
      Array.isArray(this.route.getCurrentNavigation().extras.state)
    ){
      this.info = this.route.getCurrentNavigation().extras.state;
      this.haveInformation = true;
    }

    this.getInformation();
  }

  ngOnInit(){}

  private async getInformation(){
    this.proyects = [];
    // this.answersSheet = JSON.parse(localStorage.getItem('answers'));
    this.allocation = JSON.parse(localStorage.getItem('allocation'));
    this.allocationId = this.allocation ? this.allocation['id'] : undefined;
    const cuestionario = JSON.parse(localStorage.getItem('cuestionario'));

    const responsables = await this.service.getResponsables(this.allocation['institution_id']);
    this.responsibles = responsables.map( r =>( {...r}));

    this.ListelementosCategories(cuestionario.categories, null);

    const data = await this.service.getProjects();

    for( const dat of data.projects){
      const ex = this.questionsForPlans.find( d => Number(d.id) === Number(dat.question.id));
      const matchesAllocation = Number(dat.allocationId) === Number(this.allocationId);
      if (ex && matchesAllocation) {
        const activities = await this.service.getActivities(dat.id);
        const acti = activities.map( act => {
          return {
            name: act.name,
            start_date: moment(act.start_date.split('T')[0]),
            end_date: moment(act.due_date.split('T')[0]),
            startDate: moment(act.start_date.split('T')[0]).format('YYYY-MM-DD'),
            endDate: moment(act.due_date.split('T')[0]).format('YYYY-MM-DD'),
            id: act.id,
            idProyect: dat.id,
            responsible: act.responsible,
          }
        });

        const proyect = {
          name: dat.name,
          questionId: dat.question.id,
          id: dat.id,
          start_date: undefined,
          end_date: undefined,
          startDate: undefined,
          endDate: undefined,
          activities: acti,
          check: false,
          responsible: dat.responsible,
          adicionales: dat.adicionales
        };
        this.proyects.push(proyect)
      }
    }
    this.getFechasProjectosAll();

    if(this.haveInformation){
      await this.saveInformationResultados();
    }

    this.editTable = true;
    this.viewTablero = true;
  }
  private getFechasProjectosAll(){
    var startAll = undefined, endAll = undefined;
    for( const p of this.proyects){
      var start = undefined, end = undefined;
      p.activities.forEach( act => {
        if(start === undefined || start.isAfter( act.start_date )){
          start = act.start_date;
        }

        if(end === undefined || end.isBefore( act.end_date )){
          end = act.end_date;
        }
      });

      p.start_date= start;
      p.end_date= end;
      p.startDate= start!==undefined?start.format('YYYY-MM-DD'):undefined;
      p.endDate= end!==undefined?end.format('YYYY-MM-DD'):undefined;

      if(startAll === undefined || ( startAll.isAfter( p.start_date ) && p.start_date !== undefined)){
        startAll = p.start_date;
      }

      if(endAll === undefined || ( endAll.isBefore( p.end_date ) && p.end_date !== undefined)){
        endAll = p.end_date;
      }
    }
    this.aditionals = this.proyects[0]?.adicionales.length > 0? this.proyects[0].adicionales.map( r => { return {...r}}): [];
    this.getYears(startAll, endAll);
  }
  private getYears(inicio: Moment, fin: Moment){
    if(inicio !== undefined){
      const anios: any[] = [];
      const periodos = this.years.map( y => { return {...y}});

      let current = inicio.clone().startOf('year');

      while (current.isSameOrBefore(fin)) {
        anios.push({
          anio: current.year(),
          name: current.year(),
          check: false,
        });
        current.add(1, 'year');
      }

      this.years = anios;
      var selec = false;

      if(periodos.length !== 0){
        const sel = periodos.find(e => e.check === true);
        const per = this.years.find(e => e.name === sel.name);
        if(per){
          per.check = true;
          selec = true;
        }
      }

      if(!selec){
        var anio = moment().year();
        if( !moment( anio, 'YYYY' ).isBetween(moment(anios[0].anio, 'YYYY'), moment(anios[anios.length-1].anio, 'YYYY'), 'year', "[]") ){
          moment(anio).isBefore(anios[0], 'year')? anios[0].check = true:anios[anios.length-1].check = true;
          moment(anio).isBefore(anios[0], 'year')? this.meses = this.getMesesConDias(anios[0].anio): this.meses = this.getMesesConDias(anios[anios.length-1].anio);
          moment(anio).isBefore(anios[0], 'year')? this.setYear(anios[0].anio):this.setYear(anios[anios.length-1].anio);
        }else{
          const an = anios.find(a => a.anio === anio);
          an.check = true;
          this.meses = this.getMesesConDias(an.anio);
          this.setYear(an.anio);
        }
      }
    }
    this.getProyects(true, true);
  }
  /** Cambio de año */
  yearChange(event){
    this.years.forEach( anio => {
      anio.anio === event.anio ? anio.check = true:anio.check = false;
      anio.anio === event.anio ? this.getMesesConDias(anio.anio):'';
      anio.anio === event.anio ? this.setYear(anio.anio):'';
    });
    this.getProyects(true, true);
  }
  /* Preguntas */
  public questionExist(id){
    const exis = this.proyects.find(c => c.questionId === id);
    if( this.gantGroupId && exis ){
      const ex = this.proyects.find(c => c.id === this.gantGroupId);
      if(ex.id === exis.id){
        return true;
      }
    }
    if(exis){
      return false;
    }
    return true;
  }
  delimitOptions(text){
    if(text.length > 50){
      text = text.substring(0,50)+('...');
    }
    return text;
  }
  getSelectedQuestionText(){
    const questionId = this.formProy.controls.questionId.value;
    if(questionId){
      const question = this.questionsForPlans.find(q => q.id === questionId);
      return question ? question.descripcion : '';
    }
    return '';
  }
  /* obtención elementos */
  private ListelementosCategories(elements, id){
    for(const e of elements){
      const quest = this.structureQuestions(e.questions);
      if(quest.length != 0){
        this.questionsSelect.push({
          element: e.name,
          questions: quest
        });
      }
      this.questionsForPlans = this.questionsForPlans.concat(quest);
    }
  }
  private structureQuestions(questions){
    var newQuestions = [];

    for(const q of questions){
      var res = [];
      for(const r of q.answers_options){
        res.push({
          id: r.id,
          respuesta: r.description,
          score: r.score,
        });
      }
      const answer = this.answersSheet.find(c => c.idQuestion === q.id);
      var valor = 0;

      try{
        valor = res.find(c => c.id === answer.idAnswer).score*10/10;
      }catch(err){
      }

      valor = Number(valor.toFixed(1));

      newQuestions.push({
        id: q.id,
        descripcion: q.description,
        ponderacion: valor,
      });
    }

    return newQuestions;
  }
  /* Cambio de asignación */
  /* eventos */
  public printDate(date){
    return moment(date).format('MMM-YY')
  }
  public writeDate(date){
    const fecha = moment(moment.unix(date).toDate()).format('DD-MM-YYYY');
    if(fecha === 'Invalid date'){
      return '';
    }
    return fecha;
  }
  /* Modal */
  public closeModal(id?){
    this.edit = false;
    this.gantGroupId = undefined;
    this.gantActivityId = undefined;
    this.gantAditionalId = undefined;
    this.formActi.reset(this.defaultValuesActi);
    this.formProy.reset(this.defaultValuesProy);
    this.formAdit.reset(this.defaultValuesAdit);

    this.modalProjects = false;
    this.modalActivities = false;
    this.modalAdittional = false;
    // document.getElementById(id).style.display = "none";
  }
  public openModal(id, item?){
    switch(id){
      case 1:
        this.modalProjects = true;
        break;
      case 2:
        if(item){
          this.gantGroupId = item.id;
        }
        this.modalActivities = true;
        break;
      case 3:
        if(item){
          this.gantAditionalId = item.nombre;
          this.formAdit.controls.name.setValue(item.nombre);
          this.formAdit.controls.type.setValue(item.tipo.toLowerCase());
        }
        this.modalAdittional = true;
        break;
    }
  }
  public editItem(item){
    this.edit = true;
    if(item.activities === undefined){
      const proj = this.proyects.find(p => p.id === item.idProyect);
      const act = proj.activities.find(a => a.id === item.id);
      this.formActi.controls.name.setValue(act.name);
      this.formActi.controls.start_date.setValue(act.start_date.format('YYYY-MM-DD'));
      this.formActi.controls.end_date.setValue(act.end_date.format('YYYY-MM-DD'));
      this.formActi.controls.responsible.setValue(act.responsible?act.responsible.id:'');
      this.gantActivityId = item.id;
      this.gantGroupId = item.idProyect;
      this.openModal(2);
    }else{
      const proy = this.proyects.find(c => c.id === item.id );
      this.formProy.controls.name.setValue(proy.name);
      this.formProy.controls.questionId.setValue(proy.questionId);
      this.formProy.controls.responsible.setValue(proy.responsible?proy.responsible.id:'');
      this.gantGroupId = item.id;
      this.openModal(1);
    }
  }
  public async deleteItem(item){
    
    const acepto = await messages.confirmationSave(
      this.translate.instant('acciones.delete-item'),
      `<strong> ${item.name} </strong> <br> ${this.translate.instant('acciones.continuar')}`,
      this.translate
    )
    
    if(acepto){
      messages.messageSaving(this.translate.instant('acciones.deleting-item'),this.translate.instant('acciones.espera'));
      if(item.idProyect !== undefined){
        const proj = this.proyects.find(p => p.id === item.idProyect);
        proj.activities = proj.activities.filter(a => a.id !== item.id);
        try {
          await firstValueFrom(
            this.service.deleteActivities(item.id)
          );
        } catch (error) {
          messages.errorMessageGraph(error.error.message);
          return;
        }
      }else{
        this.proyects = this.proyects.filter(p => p.id !== item.id);
        try{
          await firstValueFrom(
            this.service.deleteProject(item.id)
          );
        } catch(error){
          messages.errorMessageGraph(error.error.message);
          return;
        }
      }

      
      this.getFechasProjectosAll();
      this.cdr.detectChanges();
      this.gantGroupId = undefined;
      this.gantActivityId = undefined;
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.exito-delete'));
    }
  }
  /** Mostrar o ocultar */
  public mostrarTodasLosPlanes(){
    this.mostrarAllPlanes = !this.mostrarAllPlanes;
    this.proyects.forEach(p =>{
      p.check = this.mostrarAllPlanes;
    });
  }
  public mostrarPlanes(plan){
    plan.check = !plan.check;
  }
  public mostrarActividad(actividad){
    const per = this.years.find( an => an.check === true).anio;
    var periodo = false;
    if( moment(per, 'YYYY').isBetween(actividad.start_date, actividad.end_date, 'year', '[]') ){
      periodo = true;
    }

    var responsable = false;
    if(this.viewAllresponsiblesActivity){
      responsable = true;
    }else{
      const ex = this.viewResponsablesActivity.find(pl => pl.id === actividad.responsible?.id);
      responsable = ex?.check??false;
    }
    return periodo && responsable;
  }
  /* Guardado de información */
  // Vieniendo desde otro tablero
  public async saveInformationResultados(){
    var array = '';
    messages.messageSaving(this.translate.instant('acciones.guardando'), this.translate.instant('acciones.espera'));
    if(isArray(this.info)){
      for(let el of this.info){
        const exis = this.proyects.find(c => c.questionId === el.idQuestion);
        if(exis === undefined){
          const ques = this.questionsForPlans.find(c => c.id === el.idQuestion);
          const name = ques.descripcion;
  
          try {
            const proj = {
              name: name,
              questionId: ques.id,
              allocationId: this.allocationId,
              responsible: undefined,
              id: '',
              code: '',
              activities: [],
              start_date: undefined,
              end_date: undefined,
              startDate: undefined,
              endDate: undefined,
              check: false,
              adicionales: [],
            }

            const response = await firstValueFrom(
              this.service.postProjects(proj)
            );

            proj.id = response['data'].id;
            array += `${name} <span style="color: green"> Creado </span> <br>`;

            if(this.aditionals.length !== 0){
              const adicionalesProyect = [];
              for(const adicional of this.aditionals){
                const ad = {
                  projectId: proj.id,
                  nombre: adicional.nombre,
                  tipo: adicional.tipo.toLowerCase(),
                }

                try{
                  const resp = await firstValueFrom(this.service.postAditional(ad));
                  adicionalesProyect.push(resp['data']);
                }catch(err){
                  messages.errorMessageGraph(err);
                  return;
                }
              }
              proj.adicionales = adicionalesProyect;
            }

            this.proyects.push(proj);
            this.getProyects();
            this.cdr.detectChanges();
          } catch (error) {
            messages.errorMessageGraph(error);
            return;
          }
        }else{
          const ques = this.questionsForPlans.find(c => c.id === el.idQuestion);
          const name = ques.descripcion;
          array +=`${name} <span style="color: red"> Ya existe </span> <br>`;
        }
      }
    }
    Swal.close();
    messages.infoMessageGraph(array)
    return ;
  }
  // Guardando información desde el modal proyectos
  public async saveInformationProyects(){
    messages.messageSaving(this.translate.instant('acciones.guardando'),this.translate.instant('acciones.espera'));
    const name = this.formProy.controls.name.value;
    const questionId = this.formProy.controls.questionId.value;
    const responsible = this.formProy.controls.responsible.value;

    if(this.gantGroupId == undefined){
      try {
        const proj = {
          name: name,
          questionId: questionId,
          allocationId: this.allocationId,
          responsible: responsible,
          id: '',
          code: '',
          activities: [],
          start_date: undefined,
          end_date: undefined,
          startDate: undefined,
          endDate: undefined,
          check: false,
          adicionales: [],
        }

        const response = await firstValueFrom(
          this.service.postProjects(proj)
        );

        proj.id = response['data'].id;
        const res = this.responsibles.find(r => r.id === Number(responsible));
        proj.responsible = res;

        if(this.aditionals.length !== 0){
          const adicionalesProyect = [];
          for(const adicional of this.aditionals){
            const ad = {
              projectId: proj.id,
              nombre: adicional.nombre,
              tipo: adicional.tipo.toLowerCase(),
            }

            try{
              const resp = await firstValueFrom(this.service.postAditional(ad));
              adicionalesProyect.push(resp['data']);
            }catch(err){
              messages.errorMessageGraph(err);
              return;
            }
          }
          proj.adicionales = adicionalesProyect;
        }

        this.proyects.push(proj);
        this.getProyects();
        this.cdr.detectChanges();
      } catch (error) {
        messages.errorMessageGraph(error);
        return;
      }
    }else{
      const proy = this.proyects.find(c => c.id === this.gantGroupId);
      if(proy !== undefined){
        proy.name = name;
        proy.questionId = questionId;
        proy.responsible = responsible;
        try{
          const resp = await firstValueFrom(
            this.service.patchProjects(proy)
          );
          const res = this.responsibles.find(r => r.id === Number(responsible));
          proy.responsible = res;
        }catch(error){
          messages.errorMessageGraph(error.error.message);
          return;
        }
      }

    }

    this.gant = [...this.gant];
    this.cdr.detectChanges();

    this.gantGroupId = undefined;
    Swal.close();
    messages.succesMessageGraph(this.translate.instant('acciones.exito'));
    this.formProy.reset(this.defaultValuesProy);
    this.closeModal('proyects');
  }
  // Guardando información desde el modal actividades
  public async saveInformationActivities(){
    messages.messageSaving(this.translate.instant('acciones.guardando'),this.translate.instant('acciones.espera'));
    
    const name = this.formActi.controls.name.value;
    const start_date = this.formActi.controls.start_date.value;
    const end_date = this.formActi.controls.end_date.value;
    const responsable = this.formActi.controls.responsible.value;

    if(this.gantActivityId == undefined){
      var aditionals = []
      if(this.aditionals.length !== 0){
        for(let ad of this.aditionals){
          aditionals.push({
            name: ad.name,
            type: ad.type,
            activityId: this.activities.length+1,
            moneda: 0,
            archivos: '',
            nota: '',      
          })
        }
      }

      try{
        const proj = this.proyects.find(d => d.id === this.gantGroupId);
        const act = {
          name: name,
          start_date: start_date,
          end_date: end_date,
          responsable: responsable,
          id: '',
          code: '',
          idProyect: proj.id,
          aditional: aditionals,
          responsible: responsable
        }
        const res = await firstValueFrom(
          this.service.postActivities(act)
        );
        act.id = res['data'].id;
        const resp = this.responsibles.find(r => r.id === Number(responsable));
        const newAct = {
          name: act.name,
          start_date: moment(act.start_date),
          end_date: moment(act.end_date),
          startDate: act.start_date,
          endDate: act.end_date,
          idProyect: proj.id,
          id: act.id,
          code: '',
          responsible: resp
        }
        
        proj.activities.push(newAct);
      }catch(error){
        messages.errorMessageGraph(error.error.message);
        return;
      }
    }else{
      const proj = this.proyects.find(p => p.id === this.gantGroupId);
      const act = proj.activities.find(a => a.id === this.gantActivityId);

      const actActu = {
        name: name,
        start_date: start_date,
        end_date: end_date,
        id: act.id,
        code: act.code,
        idProyect: proj.id,
        responsible: responsable,
      }

      try{
        await firstValueFrom(
          this.service.patchActivities(actActu)
        );
      }catch(err){
        messages.errorMessageGraph(err);
        return;
      }

      act.name = name;
      act.start_date = moment(start_date);
      act.end_date = moment(end_date);
      act.startDate = start_date;
      act.endDate = end_date;
      const resp = this.responsibles.find(r => r.id === Number(responsable));
      act.responsible = resp;
    }
    this.getFechasProjectosAll();
    this.cdr.detectChanges();

    this.formActi.reset(this.defaultValuesActi);
    this.gantGroupId = undefined;
    this.gantActivityId = undefined;
    Swal.close();
    messages.succesMessageGraph(this.translate.instant('acciones.exito'));
    this.closeModal('activities');
  }
  /** Clear filters */
  borrarFiltro(){
    this.viewTablero = false;
    this.viewAllresponsiblesActivity = true;
    this.viewAllresponsibles = true;
    this.getInformation();
  }
  //
  private getProyects(calcRes?, calcResAct?){
    this.gant = [];
    if(this.years.length !== 0){
      const per = this.years.find( an => an.check === true).anio;
      this.proyects.forEach(p => {
        var responsable = false;
        if(this.viewAllresponsibles){
          responsable = true;
        }else{
          const ex = this.viewResponsables.find(pl => pl.id === p.responsible?.id);
          responsable = ex?.check??false;
        }
        if( (p.start_date === undefined && p.end_date === undefined) || ( moment(per, 'YYYY').isBetween(p.start_date, p.end_date, 'year', '[]') ) && responsable ){
          this.gant.push(p);
        }      
      });
    }else{
      this.proyects.forEach(p => {
        this.gant.push(p);
      });
    } 
    
    if(calcRes){
      var auxRes = [];
      this.gant.forEach(p =>{
        const ex = auxRes.find( r => r.id === p.responsible?.id);
        if(!ex && p.responsible){
          auxRes.push({
            ...p.responsible,
            name: p.responsible.role_name,
            check: false,
          });
        }
      });

      this.viewResponsables = auxRes;
    }
    if(calcResAct){
      var auxResActi = [];
      this.gant.forEach(p => {
        p.activities.forEach( a => {
          const ex = auxResActi.find( r => r.id === a.responsible?.id);
          if(!ex && a.responsible){
            auxResActi.push({
              ...a.responsible,
              name: a.responsible.role_name,
              check: false,
            });
          }
        });
      });
      this.viewResponsablesActivity = auxResActi;
    }
  }
  /** Cambio de responsables */
  public changeResponsibles(responsible){
    this.viewAllresponsiblesActivity = true;
    if(responsible === 'consolidado'){
      this.viewAllresponsibles = !this.viewAllresponsibles;

      if(!this.viewAllresponsibles){
        var auxResActi = [];
        this.gant.forEach(p => {
          p.activities.forEach( a => {
            const ex = auxResActi.find( r => r.id === a.responsible?.id);
            if(!ex && a.responsible){
              auxResActi.push({
                ...a.responsible,
                name: a.responsible.role_name,
                check: false,
              });
            }
          });
        });
        this.viewResponsablesActivity = auxResActi;
        return;
      }else{
        this.viewResponsables.forEach( r =>{
          r.check = false;
        });
      }
    }else{
      this.viewResponsables.forEach( r =>{
        r.id === responsible.id ? r.check = !r.check: '';
      });

      const c = this.viewResponsables.some( r => r.check === false);
      if(!c){
        this.viewAllresponsibles = true;
        this.viewResponsables.forEach( r =>{
          r.check = false;
        });
      }
    }
    this.getProyects(false, true);
  }
  public changeResponsiblesActivity(responsible){
    if(responsible === 'consolidado'){
      this.viewAllresponsiblesActivity = !this.viewAllresponsiblesActivity;

      if(!this.viewAllresponsiblesActivity){
        return;
      }else{
        this.viewResponsablesActivity.forEach( r =>{
          r.check = false;
        });
      }
    }else{
      this.viewResponsablesActivity.forEach( r =>{
        r.id === responsible.id ? r.check = !r.check: '';
      });

      const c = this.viewResponsablesActivity.some( r => r.check === false);
      if(!c){
        this.viewAllresponsiblesActivity = true;
        this.viewResponsablesActivity.forEach( r =>{
          r.check = false;
        });
      }
    }
    this.getProyects();
  }
  // Guardando información desde el modal adicionales
  public async saveInformationAditional(){
    messages.messageSaving(this.translate.instant('acciones.guardando'),this.translate.instant('acciones.espera'));
    const name = this.formAdit.controls.name.value;
    const type = this.formAdit.controls.type.value;    
    if(this.gantAditionalId === undefined){
      for(const p of this.proyects){
        const ad = {
          projectId: p.id,
          nombre: name,
          tipo: type,
        }

        try{
          const resp = await firstValueFrom(this.service.postAditional(ad));
          p.adicionales.push(resp['data']);
        }catch(err){
          messages.errorMessageGraph(err);
          return;
        }
      }
    }else{
      for ( const p of this.proyects) {
        const edit = p.adicionales.find( a => a.nombre === this.gantAditionalId);
        edit.nombre = name;
        edit.type = type.toUpperCase();

        try{
          await firstValueFrom(this.service.patchAditional(edit));
        }catch(err){
          messages.errorMessageGraph(err);
          return;
        }
      }
    }

    Swal.close();
    messages.succesMessageGraph(this.translate.instant('acciones.exito'));
    this.aditionals = this.proyects[0].adicionales.map(a => { return {...a}});
    this.closeModal();
  }
  public async deleteAdicional(adicional){
    const acepto = await messages.confirmationSave(
      this.translate.instant('acciones.delete-item'),
      `<strong> ${adicional.nombre} </strong> <br> ${this.translate.instant('acciones.continuar')}`,
      this.translate
    );
    if(acepto){
      messages.messageSaving(this.translate.instant('acciones.deleting-item'),this.translate.instant('acciones.espera'));
      for ( const p of this.proyects) {
        const edit = p.adicionales.find( a => a.nombre === adicional.nombre);
        
        try{
          await firstValueFrom(this.service.deleteAditional(edit));
          p.adicionales = p.adicionales.filter(a => a.id !== edit.id);
        }catch(err){
          messages.errorMessageGraph(err);
          return;
        }
      }
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.exito-delete'));
      this.aditionals = this.proyects[0].adicionales.map(a => { return {...a}});
      this.closeModal();
    }
  }
  private nombreDuplicidad(): ValidatorFn {
    return (formGroup: FormGroup) => {
      var nombre = formGroup.get('name').value;
      if(!nombre) {return null;}
      nombre = nombre.trim().toLowerCase()
      const existe = this.aditionals.some( el => {
        const exName = el.nombre.trim().toLowerCase();
        if(this.gantAditionalId){
          return ( exName === nombre && el.nombre !== this.gantAditionalId);
        }else{
          return exName === nombre;
        } 
      });
      if (existe) return { isValid: true};      
      return null;
    };
  }

  /** Variables para el gantt */
  private yearStart = new Date(new Date().getFullYear(), 0, 1);
  private yearDays  = 365;
  public meses = [];

  setYear(year: number): void {
    this.yearStart = new Date(year, 0, 1);
    const isLeap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    this.yearDays  = isLeap ? 366 : 365;
  }

  getBarLeft(fecha: moment.Moment | string): string {
    if (!fecha) return '0%';
    const start = moment.isMoment(fecha) ? fecha.toDate() : new Date(fecha);
    const days = (start.getTime() - this.yearStart.getTime()) / 86400000;
    return Math.max(0, (days / this.yearDays) * 100).toFixed(2) + '%';
  }

  getBarWidth(fechaIni: moment.Moment | string, fechaFin: moment.Moment | string): string {
    if (!fechaIni || !fechaFin) return '0%';
    const start = moment.isMoment(fechaIni) ? fechaIni.toDate() : new Date(fechaIni);
    const end   = moment.isMoment(fechaFin) ? fechaFin.toDate() : new Date(fechaFin);
    const days  = (end.getTime() - start.getTime()) / 86400000 + 1;
    return Math.max(0.5, (days / this.yearDays) * 100).toFixed(2) + '%';
  }

  getMesWidth(mes: any): string {
    return ((mes.value / this.yearDays) * 100).toFixed(3) + '%';
  }

  getMesesConDias(year: number) {
    return [
      { name: 'ene', value: 31 },
      { name: 'feb', value: new Date(year, 2, 0).getDate() }, // 28 o 29 según año bisiesto
      { name: 'mar', value: 31 },
      { name: 'abr', value: 30 },
      { name: 'may', value: 31 },
      { name: 'jun', value: 30 },
      { name: 'jul', value: 31 },
      { name: 'ago', value: 31 },
      { name: 'sep', value: 30 },
      { name: 'oct', value: 31 },
      { name: 'nov', value: 30 },
      { name: 'dic', value: 31 },
    ];
  }
}
